import React, { useState, useEffect, useContext } from "react";
import loaderContext from "../../context/loader/LoaderContext";
import { t } from "i18next";
import {
  Calendar,
  Checkbox,
  PrimaryButton,
  SearchBox,
  TextField,
  TooltipHost,
  defaultCalendarStrings,
} from "@fluentui/react";
import Moment from "moment";
import userContext from "../../context/users/UserContext";
import ListViewV3 from "../../components/ListViewV3/ListViewV3";
import toastContext from "../../context/toast/ToastContext";
import {
  deleteReportTemplateApi,
  getReportTemplatesListByTab,
} from "../../service/MasterService";
import {
  ClientReportTemplateColumn,
  CustomReportTemplateColumn,
  reportTemplateInitialFilterObj,
} from "./helper/helper";
import { useNavigate } from "react-router";
import ReportTemplateContent from "./ReportTemplateContent";
import ConfirmModal from "../../components/Modal/ConfirmModal";
import { searchStyle } from "../IssuesAndTroubleshooting/helper/helper";
import { checkboxFilterStyle } from "../StudyList/helpers/ConstantStyles";
import ModalFooter from "../../components/Modal/ModalFooter";
import AddRestrictionForClient from "./AddRestrictionForClient";
import ModalHeader from "../../components/Modal/ModalHeader";
import { useFormik } from "formik";
import { RestrictionSchemaForClientReportTemplate } from "../../Schemas/RestrictionSchemaForClientReportTemplate";
import ModalMain from "../../components/Modal/ModalMain";
import { USERTYPES } from "../../constants/Constants";
import { addClientReportRestriction } from "../../service/StudyReportService";

const ClientReportTemplate = ({ modalityList, clientList, tabId }) => {
  const { roles, firmId } = useContext(userContext);
  const [selectedRow, setSelectedRow] = useState(0);
  const [rowDetails, setRowDetails] = useState("");
  const { setLoaderRunning, ref } = useContext(loaderContext);
  const { showToastv2 } = useContext(toastContext);
  const [auditLogList, setAuditLogList] = useState([]);
  const navigate = useNavigate();
  const [activeDataQuery, setActiveDataQuery] = useState([]);
  const [clientData, setClientData] = useState([]);

  const [deletedId, setDeletedId] = useState();
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [displayListAppliedFilter, setDisplayListAppliedFilter] = useState([]);

  const [listForFilter, setListForFilters] = useState(reportTemplateInitialFilterObj);
  const [storeListForFilter, setStoreListForFilters] = useState(reportTemplateInitialFilterObj);
  const [list, setList] = useState({modalityList: modalityList, clientList: clientList, radiologistList: null});
  const [storeList, setStoreList] = useState({modalityList: modalityList, clientList: clientList, radiologistList: null});

  const [openRestrictionModal, setOpenRestrictionModal] = useState(false);
  const [selectedModalityList, setSelectedModalityList] = useState([]);
  const [restrictedModalityErrorMsg, setRestrictedModalityErrorMsg] =
    useState("");

  const [paginationObj, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [filterObj, setFilterObj] = useState({
    filterInput: null,
    filterUpdate: 0,
  });
  const [sortObj, setSortObj] = useState({
    sortFieldText: "",
    sortFieldValue: "",
    sortDir: false,
    selected: false,
  });

  const fetchData = async (options) => {
    let page = options.page;
    let pageSize = options.pageSize;
    console.log("--- Fetching Data ----", options);
    let sortParams = "id";
    let sortyByDir = false;

    if (
      options.sortObj.sortFieldValue != undefined &&
      options.sortObj.sortFieldValue.length > 0
    ) {
      sortParams = options.sortObj.sortFieldValue;
      sortyByDir = options.sortObj.sortDir;
    }

    let body = {
      paginationDto: {
        pageNumber: page,
        pageSize: 10,
        filterInput:
          options.filterObj.filterInput == null
            ? ""
            : options.filterObj.filterInput,
      },
      modalityIds: Object.values(listForFilter?.modalityIds).map(
        (item) => item.value
      ),
      clientIds: Object.values(listForFilter?.clientIds).map(
        (item) => item.value
      )
    };

    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      const response = await getReportTemplatesListByTab(tabId, body);
      let data = null;
      let pageCount = null;
      if (response.status === 200 && response.data.result === "SUCCESS") {
        console.log("---- Response ----", response);
        const results = response.data.data.reportTemplatesList;
        setRowDetails(results[0]?.report);
        setClientData(response.data.data.clientReportTemplatesByUserId);

        const pageSize = 10;
        const totalElement = response.data.data.total;
        data = results;
        pageCount = Math.ceil(totalElement / pageSize);
        setLoaderRunning(false);
        ref.current.complete();
        console.log("--- Returning ---",data);
        return {
          rows: data,
          pageCount: pageCount,
          userData: response.data.data.reportTemplatesByUserId,
          clientData: response.data.data.clientReportTemplatesByUserId,
        };
      } else {
        setLoaderRunning(false);
        ref.current.complete();
        return {
          rows: data,
          pageCount: pageCount,
          userData: response.data.data.reportTemplatesByUserId,
          clientData: response.data.data.clientReportTemplatesByUserId,
        };
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

  const handleUserClick = (cell) => {
    let row = cell.row;
    setSelectedRow(row.index);
    setRowDetails(row.original.report);
  };

  const deleteConfirmModal = (reportTemplateId) => {
    setDeletedId(reportTemplateId);
    setShowDeleteConfirmModal(true);
  };

  const handleEdit = (reportTemplateId) => {
    navigate("/report/edit/template/" + tabId + "?id=" + reportTemplateId, {});
  };

  const columns = ClientReportTemplateColumn(
    roles[0],
    clientData,
    handleEdit,
    deleteConfirmModal
  );

  useEffect(() => {
    if (activeDataQuery != undefined && activeDataQuery.data != undefined) {
      setRowDetails(activeDataQuery?.data?.rows[0]?.report);
      setClientData(activeDataQuery?.data.clientData);
    }
  }, [activeDataQuery]);


  const buttonsTopBar = [
    {
      key: "1",
      button: (
        <div
          className="add-button-list-view"
          onClick={() => {
            navigate("/report/add/template/" + tabId);
          }}
        >
          {/* <AddButton  text={t("supervisor.add-supervisor")} /> */}
          <PrimaryButton
            text={"Create new template"}
            className={
              "common-default-active-button list-view-top-buttons-styles"
            }
          />
        </div>
      ),
    },{
      key: "2",
      button: (
        <div
          className="add-button-list-view"
          onClick={() => {
            handleOpenRestrictionModal();
          }}
        >
          {/* <AddButton  text={t("supervisor.add-supervisor")} /> */}
          <PrimaryButton
            text={"Add Restrictions"}
            className={
              "common-default-active-button list-view-top-buttons-styles"
            }
          />
        </div>
      ),
    },
  ];

  const initialData = {
    modalityId: [],
    firmId:
      roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR
        ? firmId
        : "",
    clientId: "",
  };

  const {
    dirty,
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setValues,
    setErrors
  } = useFormik({
    initialValues: initialData,
    validationSchema: RestrictionSchemaForClientReportTemplate(t),
    enableReinitialize: true,
    onSubmit: async (values, action) => {
      // if (selectedModalityList.length <= 0) {
      //   setRestrictedModalityErrorMsg("Modality is required");
      //   return;
      // }
      values.firmId = values.firmId == 0 || values.firmId == "" ? null : values.firmId;
      values.clientId = values.clientId == 0 || values.clientId == "" ? null : values.clientId;
      values.modalityId = selectedModalityList;
      
      let payload = {
        firmId: values.firmId,
        clientId: values.clientId,
        modalityIds: selectedModalityList
      }
      setLoaderRunning(true);
      ref.current.continuousStart();
      console.log("payload--", payload);
      const response = await addClientReportRestriction(payload);
      console.log("response---",response);
      
      if(response.data.data == true){
        console.log("saved successfully");
        showToastv2("success", "saved successfully");
      }
      setErrors({});
      hideOpenRestrictionModal();
      action.resetForm();
      setLoaderRunning(false);
      ref.current.complete();
    },
  });

  const handleOpenRestrictionModal = () => {
    console.log("dbcdhvchdv");
    setOpenRestrictionModal(true);
  };

  const hideOpenRestrictionModal = () => {
    setValues(initialData);
    setErrors({});
    setRestrictedModalityErrorMsg("");
    setOpenRestrictionModal(false);
    setSelectedModalityList([]);
  };

  const PrimaryButtonList = [
    {
      title: t("button.save"),
      onclick: handleSubmit,
    },
  ];
  const DefaultButtonList = [
    {
      title: t("button.cancel"),
      onclick: hideOpenRestrictionModal,
    },
  ];

  const modalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        showPatientDetails={false}
        heading="Add Restrictions"
        handleCancel={hideOpenRestrictionModal}
      />
    ),
    body: (
      <AddRestrictionForClient
        values={values}
        handleChange={handleChange}
        handleBlur={handleBlur}
        touched={touched}
        errors={errors}
        tabId={tabId}
        userRole={roles[0]}
        setValues={setValues}
        selectedModalityList={selectedModalityList}
        setSelectedModalityList={setSelectedModalityList}
        setRestrictedModalityErrorMsg={setRestrictedModalityErrorMsg}
        restrictedModalityErrorMsg={restrictedModalityErrorMsg}
      />
    ),
    footer: (
      <ModalFooter
        DefaultButtonList={DefaultButtonList}
        PrimaryButtonList={PrimaryButtonList}
      />
    ),
    width: "600px",
  };

  const deleteReportTemplate = async () => {
    let payload = { reportTemplateId: deletedId };
    let response = await deleteReportTemplateApi(payload);
    if (response.data.result === "SUCCESS") {
      showToastv2("success", response.data.message);
    } else {
      showToastv2("error", response.data.message);
    }
    setShowDeleteConfirmModal(false);
    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });

    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
    setSelectedRow(0);
  };

  useEffect(()=>{
    console.log("--- Checked Data ---", clientList);
  },[clientList]);


  const handleApplyClick = (filterValue) => {
    //TODO
    if (filterValue != undefined) filterValue = filterValue.trim();
    const transformedArray = Object.keys(listForFilter)
                  .flatMap(key => {
                    if (Array.isArray(listForFilter[key])) {
                      return listForFilter[key].filter(item => item !== null && item !== undefined);
                    }
                    return [];
                  });
    console.log("--- Transformed Array ---", listForFilter);
    setDisplayListAppliedFilter(transformedArray);

    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });
    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        newItem.filterInput = filterValue;
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  };

  const filterList = (searchInput) => {
    //TODO
  };

  const handleClearFilter = () => {
    //TODO
    setDisplayListAppliedFilter([]);
    setListForFilters(reportTemplateInitialFilterObj);
    setStoreListForFilters(reportTemplateInitialFilterObj);
    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });

    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        newItem.filterInput = "";
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  };

  const removeBadgeFromFilter = (toBeRemoveObj) => {
    //TODO
    const updatedFilterList = {};
    for (const key in listForFilter) {
      if (Array.isArray(listForFilter[key])) {
        updatedFilterList[key] = listForFilter[key].filter(item => item.label !== toBeRemoveObj.label);
      } else {
        updatedFilterList[key] = listForFilter[key];
      }
    }

    setListForFilters(updatedFilterList);
    setStoreListForFilters(updatedFilterList);

    setDisplayListAppliedFilter((current) =>
      current.filter((item) => item.label !== toBeRemoveObj.label)
    );

    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });

    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  }

  const handlePopupClose = () => {
    setList(storeList);
  }

  return (
    <>
      {showDeleteConfirmModal && (
        <ConfirmModal
          handleConfirm={deleteReportTemplate}
          handleNotConfirm={() => {
            setShowDeleteConfirmModal(!showDeleteConfirmModal);
          }}
          showConfirmModal={showDeleteConfirmModal}
          message={t("string-literals.delete-report-template")}
          title={t("confirm-message.confirm")}
          confirmButtonText={t("confirm-message.yes")}
        />
      )}
      {openRestrictionModal && (
        <ModalMain
          updatedModal={true}
          showModal={openRestrictionModal}
          modalDetails={modalDetails}
        />
      )}
      <ListViewV3
        buttonsTopBar={buttonsTopBar}
        fetchData={fetchData}
        columns={columns}
        handleUserClick={handleUserClick}
        filterObj={filterObj}
        setFilterObj={setFilterObj}
        sortObj={sortObj}
        setSortObj={setSortObj}
        setPagination={setPagination}
        paginationObj={paginationObj}
        showSideBySide={true}
        tabHeaderPresent={true}
        uniqueKey={"ClientReport"}
        selectedRow={selectedRow}
        setActiveDataQuery={setActiveDataQuery}
        selectedRowComponent={<SelectedRowComponent rowDetails={rowDetails} />}
        constantFilterHeight={false}
        placeholder={"Report Name"}
        enhancedFilter={true}
        showSort={false}
        handleApplyClick={handleApplyClick}
        displayListAppliedFilter={displayListAppliedFilter}
        filterList={filterList}
        handleClearFilter={handleClearFilter}
        removeBadgeFromFilter={removeBadgeFromFilter}
        handlePopupClose={handlePopupClose}
        filterPopUpComponent={
          <FilterPopUpComponent
            setList={setList}
            list={list}
            storeList={storeList}
            listForFilter={listForFilter}
            setListForFilters={setListForFilters}
          />
        }
        pointer={false}
      />
    </>
  );
};

export default ClientReportTemplate;

const SelectedRowComponent = ({ rowDetails }) => {
  return (
    <>
     {rowDetails != null && rowDetails != undefined && rowDetails?.length > 0 &&
      <div
        className="h100 w100"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          className="reportTemplateHtmlContent"
          dangerouslySetInnerHTML={{ __html: rowDetails }}
        ></div>
      </div>
    }
    </>
  );
};

export const FilterPopUpComponent = ({
  setList,
  list,
  storeList,
  listForFilter,
  setListForFilters
}) => {

    const filterList = (searchInput,filterName) => {
      if (searchInput != null && searchInput != undefined)
        searchInput = searchInput.trim();
      let searchValue = searchInput.toLowerCase();
      let allTemp = storeList[filterName];
      if (searchValue != "") {
        const filteredData = allTemp.filter((item) => {
          return item.name.toLowerCase().includes(searchValue);
        });
        setList(()=>{
          const newItem = {...list};
          newItem[filterName] = filteredData;
          return newItem;
       })
      } else {
        setList(()=>{
          const newItem = {...list};
          newItem[filterName] = storeList[filterName];
          return newItem;
       })
      }
    };

  const customToolTipClassName = {
    root: "audit-logs-user-action-text",
  };

  return (
    <div style={{ display: "flex" }}>
     <div className="align-filter-section" style={{ width: "15%" }}>
        <span className="filter-section-text">{t("navbar.modalities")}</span>
        <SearchBox
          placeholder="Search"
          styles={searchStyle}
          onClear={(ev) => {
            // console.log("Custom onClear Called");
          }}
          onChange={(ev, newValue) => {
            filterList(newValue,"modalityList");
          }}
        />
        <div
          className={`modal-scroll study-list-filter-section ${
            list?.modalityList?.length == 0 ? "no-result-container" : ""
          }`}
        >
          {list?.modalityList != null &&
            Array.from(list?.modalityList).map((itemValue) => {
              return (
                <Checkbox
                  key={itemValue.id}
                  label={itemValue.name}
                  name={itemValue.name}
                  styles={checkboxFilterStyle}
                  // defaultChecked = {searchDto.modalityIds?.includes(modality.id)}
                  checked={listForFilter?.modalityIds?.some(
                    (item) => item.value === itemValue.id
                  )}
                  onChange={(e, data) => {
                    if (data) {
                      console.log("-- check --", [{
                        label: itemValue.name,
                        value: itemValue.id
                      }]);
                      setListForFilters({...listForFilter, modalityIds: [
                        ...listForFilter.modalityIds,
                        {
                        label: itemValue.name,
                        value: itemValue.id
                      }]});
                    } else {
                      console.log("-- uncheck --");
                      setListForFilters((currentListForFilters) => ({
                        ...currentListForFilters,
                        modalityIds: currentListForFilters.modalityIds.filter(
                          (item) => item.value !== itemValue.id
                        )
                      }));
                    }
                  }}
                />
              );
            })}
          {list?.modalityList != null && list?.modalityList?.length == 0 && (
            <div className="no-result-message">
              {t("search-message.no-result")}
            </div>
          )}
        </div>
      </div>
      <div className="filter-section-seperator"></div>
      <div className="align-filter-section" style={{ width: "15%" }}>
        <span className="filter-section-text">{t("navbar.clients")}</span>
        <SearchBox
          placeholder="Search"
          styles={searchStyle}
          onClear={(ev) => {
            // console.log("Custom onClear Called");
          }}
          onChange={(ev, newValue) => {
            filterList(newValue,"clientList");
          }}
        />
        <div
          className={`modal-scroll study-list-filter-section ${
            list?.modalityList?.length == 0 ? "no-result-container" : ""
          }`}
        >
          {list?.clientList != null &&
            Array.from(list?.clientList).map((itemValue) => {
              return (
                <Checkbox
                  key={itemValue.id}
                  label={itemValue.name}
                  name={itemValue.name}
                  styles={checkboxFilterStyle}
                  // defaultChecked = {searchDto.modalityIds?.includes(modality.id)}
                  checked={listForFilter?.clientIds?.some(
                    (item) => item.value === itemValue.id
                  )}
                  onChange={(e, data) => {
                    if (data) {
                      console.log("-- check --", [{
                        label: itemValue.name,
                        value: itemValue.id
                      }]);
                      setListForFilters({...listForFilter, clientIds: [
                        ...listForFilter.clientIds,
                        {
                        label: itemValue.name,
                        value: itemValue.id
                      }]});
                    } else {
                      console.log("-- uncheck --");
                      setListForFilters((currentListForFilters) => ({
                        ...currentListForFilters,
                        clientIds: currentListForFilters?.clientIds.filter(
                          (item) => item.value !== itemValue.id
                        )
                      }));
                    }
                  }}
                />
              );
            })}
          {list?.clientList != null && list?.clientList?.length == 0 && (
            <div className="no-result-message">
              {t("search-message.no-result")}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
